import React from "react";
import useCustomizationContext from "../context/useCustomizationContext";
import {
  CONFIGURATION_LINK_CONFIGURATION_PATH,
  CONFIGURATION_LINK_FEATURES_PATH,
  CONFIGURATION_LINK_APPEARANCE_PATH,
  CONFIGURATION_LINK_BRANDING_PATH,
} from "../../../../../router/RouterUtils";
import CustomizationChangeRow from "./CustomizationChangeRow";
import useCustomizationChangeCounts from "./useCustomizationChangeInformation";

const CustomizationChangesOverview = () => {
  const {
    organizationCustomization,
    originalOrganizationCustomization,
    integrationCustomizations,
    originalIntegrationCustomizations,
    logo,
    hasLogoChange,
  } = useCustomizationContext();
  const { appearanceCount, featuresCount, configurationCount, brandingCount } =
    useCustomizationChangeCounts(
      organizationCustomization,
      originalOrganizationCustomization,
      integrationCustomizations,
      originalIntegrationCustomizations,
      logo,
      hasLogoChange,
    );
  return (
    <div className="w-100 flex flex-col gap-2">
      <CustomizationChangeRow
        name="Appearance"
        linkPath={CONFIGURATION_LINK_APPEARANCE_PATH}
        count={appearanceCount}
      />
      <CustomizationChangeRow
        name="Features"
        linkPath={CONFIGURATION_LINK_FEATURES_PATH}
        count={featuresCount}
      />
      <CustomizationChangeRow
        name="Configuration"
        linkPath={CONFIGURATION_LINK_CONFIGURATION_PATH}
        count={configurationCount}
      />
      <CustomizationChangeRow
        name="Branding"
        linkPath={CONFIGURATION_LINK_BRANDING_PATH}
        count={brandingCount}
      />
    </div>
  );
};

export default CustomizationChangesOverview;
